import { render, staticRenderFns } from "./PFLoanTerms.vue?vue&type=template&id=05bd3a42"
import script from "./PFLoanTerms.vue?vue&type=script&lang=js"
export * from "./PFLoanTerms.vue?vue&type=script&lang=js"
import style0 from "./PFLoanTerms.vue?vue&type=style&index=0&id=05bd3a42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports